import { Product } from "api";
import theme from "theme";
import Slider, { Settings as SliderSettings } from "react-slick";

import GameExtentionCard from "./GameExtentionCard";
import styled from "styled-components";
import { ButtonBase, Grid } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

type Props = {
  extentionProducts: Product[];
};

export const ExtentionCardCarousel = ({ extentionProducts }: Props) => {
  const responsiceSettings: SliderSettings = {
    responsive: [
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: theme.breakpoints.values.sm,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const ArrowButtonComponents = (props) => {
    const { onClick } = props;
    return (
      <ArrowButton onClick={onClick} align={props.align}>
        {props.align === "left" ? (
          <ArrowBackIosNewIcon sx={{ color: "text.primary" }} />
        ) : (
          <ArrowForwardIosIcon sx={{ color: "text.primary" }} />
        )}
      </ArrowButton>
    );
  };
  return (
    <SliderContainer>
      {extentionProducts.length > 3 ? (
        <Slider
          focusOnSelect
          slidesToShow={3}
          slidesToScroll={1}
          infinite
          dots
          swipeToSlide
          arrows
          speed={500}
          draggable={true}
          nextArrow={<ArrowButtonComponents align={"right"} />}
          prevArrow={<ArrowButtonComponents align={"left"} />}
          {...responsiceSettings}
        >
          {extentionProducts.map((game) => (
            <GameExtentionCard
              key={game.id}
              productId={game.id}
              thumbnailUrl={game.thumbnailUrl}
              name={game.name}
              category={game.category}
              price={game.price}
              to={`/games/${game.id}`}
              referer="store-top-page-list-extention"
            />
          ))}
        </Slider>
      ) : (
        <Grid
          container
          sx={{
            width: "auto",
            ml: "-12px",
            mr: "-12px",
            padding: { lg: "0 120px", md: " 0 60px" },
          }}
        >
          {extentionProducts.map((game) => (
            <GameExtentionCard
              key={game.id}
              productId={game.id}
              thumbnailUrl={game.thumbnailUrl}
              name={game.name}
              category={game.category}
              price={game.price}
              to={`/games/${game.id}`}
              referer="store-top-page-list-extention"
            />
          ))}
        </Grid>
      )}
    </SliderContainer>
  );
};

const ArrowButton = styled(ButtonBase)<{ align: "left" | "right" }>`
  position: absolute;
  z-index: 2;
  top: 50%;
  transform: translateY(-50%);
  ${({ align }) => align}:-10px;
  padding: 10px;
  font-size: 20px;
  border-radius: 50px;
  background: #000;
  &:hover {
    background: ${theme.palette.grey[800]};
  }
  ${theme.breakpoints.down("sm")} {
    padding: 8px;
    font-size: 16px;
  }
`;

const SliderContainer = styled.div`
  margin-left: -12px;
  margin-right: -12px;
  ${theme.breakpoints.down("sm")} {
    margin-left: -6px;
    margin-right: -6px;
  }
  .slick-track {
    display: flex;
  }
  .slick-slide {
    flex: 1;
    height: auto;
  }
  .slick-slide > div {
    display: flex;
    height: 100%;
  }

  .slick-dots {
    bottom: -30px;
  }
  .slick-dots li {
    margin: 0;
  }
  .slick-dots li button {
    padding: 6px;
  }
  .slick-dots li button:before {
    font-size: 8px;
    opacity: 1;
    color: #606060;
  }
  .slick-dots li.slick-active button:before {
    opacity: 1;
    color: #f40057;
  }
  .slick-arrow {
    z-index: 2;
    width: 56px;
    height: 56px;
    background-color: #000;
  }
`;
